export const SET_SILAL_IMAGES = 'SET_SILAL_IMAGES';
export const SET_STORE_IMAGES = 'SET_STORE_IMAGES';
export const GET_SILAL_IMAGES = 'GET_SILAL_IMAGES';
export const GET_STORE_IMAGES = 'GET_STORE_IMAGES';
export const SET_LAST_FETCHED_SILAL_IMAGES = 'SET_LAST_FETCHED_SILAL_IMAGES';
export const SET_LAST_FETCHED_STORE_IMAGES = 'SET_LAST_FETCHED_STORE_IMAGES';

export const CLEAR = 'CLEAR';

export const actionSetSilalImages = (payload: any) => ({
  type: SET_SILAL_IMAGES,
  payload,
});

export const actionGetSilalImages = (payload: any) => ({
  type: GET_SILAL_IMAGES,
  payload,
});

export const actionSetStoreImages = (payload: any) => ({
  type: SET_STORE_IMAGES,
  payload,
});

export const actionGetStoreImages = (payload: any) => ({
  type: GET_STORE_IMAGES,
  payload,
});

export const actionSetLastFetchedSilalImages = (timestamp: number) => ({
  type: SET_LAST_FETCHED_SILAL_IMAGES,
  timestamp,
});

export const actionSetLastFetchedStoreImages = (timestamp: number) => ({
  type: SET_LAST_FETCHED_STORE_IMAGES,
  timestamp,
});

export const actionLogoutImages = () => ({
  type: CLEAR,
});
